import { Product } from "libs/shared-models/src/lib/product-type";

// User-App self response
export class UserSelfResponse {
    public id: string = "";
    public email: string = "";
    public name: string = "";
    public userLanguage: string = "";
    public product: string = Product.UNDEFINED
}